export type BenchlingNodeV2Status = 'pending' | 'in-progress' | 'success' | 'warning' | 'error';

export const STATUS_COLORS: Record<BenchlingNodeV2Status | 'default', string> = {
  default: 'gray',
  error: 'red',
  'in-progress': 'blue',
  pending: 'gray',
  success: 'green',
  warning: 'orange',
};
